module.exports = "/lucky-balls/img/bonus_yellow/check_infoBar/check_011.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/check_infoBar/check_011.png
// module id = 956
// module chunks = 0